import { render, staticRenderFns } from "./trial-balance.vue?vue&type=template&id=6f3644be&scoped=true"
import script from "./trial-balance.vue?vue&type=script&lang=js"
export * from "./trial-balance.vue?vue&type=script&lang=js"
import style0 from "./trial-balance.vue?vue&type=style&index=0&id=6f3644be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3644be",
  null
  
)

export default component.exports